import React from "react";
import { Loader2, FolderOpen } from "lucide-react";
import { Progress } from "@/components/ui/progress";
import { Button } from "@/components/ui/button";

export function Spinner({ label }) {
  return <div className="flex flex-col items-center justify-center py-20 text-slate-400" data-testid="loading">
    <Loader2 className="h-6 w-6 animate-spin text-sp-orange" /><span className="mt-2 text-sm">{label || "Loading..."}</span></div>;
}

export function EmptyState({ title, subtitle, actionLabel, onAction, icon: Icon = FolderOpen, testid }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center" data-testid={testid || "empty-state"}>
      <div className="h-14 w-14 rounded-full bg-slate-100 flex items-center justify-center"><Icon className="h-6 w-6 text-slate-400" /></div>
      <div className="mt-4 font-semibold text-sp-navy">{title}</div>
      {subtitle && <div className="text-sm text-slate-500 mt-1 max-w-sm">{subtitle}</div>}
      {actionLabel && <Button data-testid="empty-action" onClick={onAction} className="mt-5 bg-sp-orange hover:bg-sp-orangedark rounded-full px-6">{actionLabel}</Button>}
    </div>
  );
}

export function StatCard({ label, value, sub, accent, testid }) {
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-5 sp-hover-card" data-testid={testid}>
      <div className="text-xs text-slate-500 uppercase tracking-wider">{label}</div>
      <div className={`text-2xl font-bold mt-1.5 ${accent ? "text-sp-orange" : "text-sp-navy"}`}>{value}</div>
      {sub && <div className="text-xs text-slate-400 mt-1">{sub}</div>}
    </div>
  );
}

export function ProgressCard({ label, value, sub }) {
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-5">
      <div className="flex justify-between items-baseline"><span className="text-xs text-slate-500 uppercase tracking-wider">{label}</span><span className="text-lg font-bold text-sp-navy">{value}%</span></div>
      <Progress value={value} className="mt-3 h-2" />
      {sub && <div className="text-xs text-slate-400 mt-2">{sub}</div>}
    </div>
  );
}

export const badgeColor = (status) => {
  const s = (status || "").toLowerCase();
  if (["completed", "paid", "approved", "pass", "won", "closed", "in stock"].some((x) => s.includes(x))) return "bg-emerald-50 text-emerald-600 border-emerald-200";
  if (["pending", "todo", "not started", "draft", "new"].some((x) => s.includes(x))) return "bg-slate-100 text-slate-600 border-slate-200";
  if (["in progress", "partially", "contacted", "site visit", "revision"].some((x) => s.includes(x))) return "bg-blue-50 text-blue-600 border-blue-200";
  if (["blocked", "overdue", "fail", "rejected", "high", "cancelled"].some((x) => s.includes(x))) return "bg-red-50 text-red-600 border-red-200";
  if (["needs attention", "warning", "medium", "negotiation", "proposal"].some((x) => s.includes(x))) return "bg-amber-50 text-amber-600 border-amber-200";
  return "bg-slate-100 text-slate-600 border-slate-200";
};

export function StatusBadge({ status }) {
  return <span className={`text-[11px] px-2 py-0.5 rounded-full border ${badgeColor(status)}`}>{status}</span>;
}
